'use client';

import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { Twitter, Facebook } from 'lucide-react';

interface ProductHeaderProps {
    name: string;
    link: string;
    openSiteText: string;
    shareUrl: string;
}

const ProductHeader: React.FC<ProductHeaderProps> = ({ name, link, openSiteText, shareUrl }) => {
    return (
        <div className="flex flex-col sm:flex-row justify-between items-center bg-white shadow-sm rounded-lg p-4 mb-4">
            <div className="flex items-center">
                <Image
                    src={`https://favicon.im/${link}`}
                    alt={`${link} favicon`}
                    width={32}
                    height={32}
                    className="mr-2"
                />
                <p className="text-3xl font-bold text-gray-900 mb-4 sm:mb-0">{name}</p>
            </div>

            <div className="flex space-x-4">
                <Link
                    href={link + "?utm_source=aitoolly.com&utm_medium=referral"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary transition-colors duration-300 hover:bg-primary-dark"
                >
                    {openSiteText}
                </Link>
                <Link
                    href={`https://twitter.com/intent/tweet?url=${shareUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline transition-colors duration-300 hover:bg-blue-100 mr-2"
                    aria-label="share to Twitter"
                >
                    <Twitter className="h-5 w-5" />
                </Link>
                <Link
                    href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline transition-colors duration-300 hover:bg-blue-100"
                    aria-label="share to Facebook"
                >
                    <Facebook className="h-5 w-5" />
                </Link>
            </div>
        </div>
    );
};

export default ProductHeader;